/* unplugin-vue-components disabled */import { render } from "./ImgScale.vue?vue&type=template&id=ed9ac30a&scoped=true"
import script from "./ImgScale.vue?vue&type=script&lang=js"
export * from "./ImgScale.vue?vue&type=script&lang=js"

import "./ImgScale.vue?vue&type=style&index=0&id=ed9ac30a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed9ac30a"]])

export default __exports__